module.exports = __webpack_public_path__ + "static/media/ic-meal-delete.f7ed75c4.svg";